import * as React from "react";
const SvgKlassenzimmerZukunft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 256, height: 192, viewBox: "0 0 256 192", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 255, height: 191, stroke: "#FF0000" }));
export default SvgKlassenzimmerZukunft;
